import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromLocation from 'app/state/location';

export const locationDetailResolverFn: ResolveFn<any> = (route, state) => {
  const store = inject(Store);
  const id = route.paramMap.get('id') ?? '';
  if (!id) return false;

  store.dispatch(fromLocation.setItem({ id: id }));
  return true;
};
